module.exports = __webpack_public_path__ + "static/img/007.9c6b353.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-eplus/007.png
// module id = 29Qa
// module chunks = 1